    (function () {
      if (window.__alvaKlaviyoIdentifyV1) return;
      window.__alvaKlaviyoIdentifyV1 = true;

      var INTERNAL = /@(global-e\.com|alva-cookware\.us|alvacookware\.com|allinox\.[a-z]+)$/i;
      var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      var lastIdentified = null;
      var pending = null;
      var inFlight = false;
      var retryTimer;
      var waitAttempts = 0;

      function isPreview() {
        var shopify = window.Shopify || {};
        return shopify.designMode || (shopify.theme && shopify.theme.role !== 'main') ||
          new URLSearchParams(window.location.search).has('preview_theme_id') ||
          Boolean(document.querySelector('script[src*="preview-bar"], iframe#preview-bar-iframe, iframe#PBarNextFrame'));
      }

      function privacyAllows() {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy) return false;
        try {
          return typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true &&
            typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
        } catch (error) { return false; }
      }

      function schedule(delay) {
        clearTimeout(retryTimer);
        retryTimer = setTimeout(function () { drain(false); }, delay);
      }

      function drain(resume) {
        if (inFlight || !pending || isPreview()) return Promise.resolve(false);
        if (resume) { pending.attempts = 0; waitAttempts = 0; clearTimeout(retryTimer); }
        if (!privacyAllows()) {
          if (!(window.Shopify && window.Shopify.customerPrivacy) && waitAttempts++ < 30) schedule(1000);
          return Promise.resolve(false);
        }
        if (!window.klaviyo || typeof window.klaviyo.identify !== 'function') {
          if (waitAttempts++ < 30) schedule(1000);
          return Promise.resolve(false);
        }
        if (pending.attempts >= 3) return Promise.resolve(false);
        var request = pending;
        request.attempts += 1;
        inFlight = true;
        function failed() {
          inFlight = false;
          if (pending !== request) return drain(false);
          if (request.attempts < 3) schedule(1500 * request.attempts);
          return false;
        }
        var result;
        try { result = window.klaviyo.identify(request.props); }
        catch (error) { return Promise.resolve(failed()); }
        return Promise.resolve(result).then(function (accepted) {
          if (!accepted) return failed();
          inFlight = false;
          if (pending !== request) return drain(false);
          if (!privacyAllows() || isPreview()) return false;
          pending = null;
          lastIdentified = request.email;
          window.__alvaKlaviyoIdentityEmail = request.email;
          window.__alvaKlaviyoIdentityVersion = Number(window.__alvaKlaviyoIdentityVersion || 0) + 1;
          document.dispatchEvent(new CustomEvent('alva:klaviyo-identified', {
            detail: { email: request.email, identity_version: window.__alvaKlaviyoIdentityVersion }
          }));
          return true;
        }, failed);
      }

      function identify(email, extra) {
        email = String(email || '').trim().toLowerCase();
        if (!EMAIL.test(email) || INTERNAL.test(email) || email === lastIdentified || isPreview()) return Promise.resolve(false);
        if (pending && pending.email === email) return drain(false);
        var props = { email: email };
        if (extra) Object.keys(extra).forEach(function (key) { if (extra[key]) props[key] = extra[key]; });
        pending = { email: email, props: props, attempts: 0 };
        waitAttempts = 0;
        return drain(false);
      }

      document.addEventListener('visitorConsentCollected', function () { drain(true); });
      window.addEventListener('online', function () { drain(true); });
      window.addEventListener('pageshow', function (event) { if (event.persisted) drain(true); });
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { drain(true); }); }
        catch (error) {}
      }

      var customer = window.__alvaKlaviyoCustomer;
      if (customer && customer.email) identify(customer.email, { first_name: customer.first_name, last_name: customer.last_name });

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.querySelector) return;
        var input = form.querySelector('input[name="contact[email]"], input[name="customer[email]"], input[type="email"]');
        if (input) identify(input.value);
      }, true);

      window.AlvaKlaviyoIdentify = { identify: identify, version: '1.2' };
    })();
